module.exports = __webpack_public_path__ + "static/media/4-17.ba9bbd05.png";